import { FormElement, Select } from 'mailup-web-components'
import {
  dynamicFieldState,
  senderConfigState
} from 'Pages/Task/recoil/state/task'

import { useIntl } from 'react-intl'
import { useRecoilState, useRecoilValue } from 'recoil'

const DynamicSenderEmail = () => {
  const intl = useIntl()
  const [{ IdSenderEmailField, customEmailValueIsDirty }, setSenderConfig] =
    useRecoilState(senderConfigState)
  const dynamicOptions = useRecoilValue(dynamicFieldState)

  const handleChange = (e) => {
    const selectedOption = dynamicOptions.find((f) => f.value === e)

    setSenderConfig((prev) => ({
      ...prev,
      IsDirty: true,
      IdSenderEmailField: selectedOption ? selectedOption.value : undefined,
      customEmailValueIsDirty: true
    }))
  }

  return (
    <div>
      <FormElement
        required
        label={intl.formatMessage({
          id: 'Load.EmailSendingWizard.CustomSenderEmailLabel'
        })}
        feedback={
          !IdSenderEmailField && customEmailValueIsDirty
            ? intl.formatMessage({
                id: 'Load.EmailSendingWizard.SenderNameRequired'
              })
            : undefined
        }
      >
        <Select
          value={IdSenderEmailField}
          onChange={handleChange}
          placeholder={intl.formatMessage({
            id: 'Load.Filters.IdentifierPlaceholder'
          })}
          options={dynamicOptions}
          error={!IdSenderEmailField && customEmailValueIsDirty}
          data-mu-test='select-dynamicOptionsEmail'
        />
      </FormElement>
    </div>
  )
}

export default DynamicSenderEmail
